module.exports = __webpack_public_path__ + "img/panchito_top_left-min.547644f0.png";